module.exports = __webpack_public_path__ + "img/strip_b+.c957ad7e.jpg";